import type { ThemeWithoutTokens } from '../theme.types';

export const calendarMonthTokens = (theme: ThemeWithoutTokens) =>
  ({
    // icon in navigation
    calendarMonthNavIconPaddingX: theme.space.component.x.m,

    // weekday
    calendarMonthWeekdayColor: theme.colors.body.text,
    calendarMonthWeekdayFontFamily: theme.typography.fontFamily.regular,
    calendarMonthWeekdayFontSize: theme.typography.fontSize.s,
    calendarMonthWeekdayFontWeight: theme.typography.fontWeight.bold,
    calendarMonthWeekdayLineHeight: theme.typography.lineHeight.m,
    calendarMonthWeekdayTextAlign: 'center',

    // day: 1, 2 … 30, 31.
    calendarMonthDayBackgroundColor: 'transparent',
    calendarMonthDayFontSize: theme.typography.fontSize.s,
    calendarMonthDayColor: theme.colors.body.text,
    calendarMonthDayTextAlign: 'center',
    calendarMonthDayLineHeight: theme.typography.lineHeight.m,
    calendarMonthDayFontFamily: theme.typography.fontFamily.regular,
    calendarMonthDayFontWeight: theme.typography.fontWeight.semibold,
    calendarMonthDayRadius: theme.radiuses.xl,
    // disabled day
    calendarMonthDayDisabledColor: theme.colors.disabled.text,
    // hovered day
    calendarMonthDayHoverBackgroundColor: theme.colors.primary.alpha,
    // selected/focused
    calendarMonthDayFocusBackgroundColor: theme.colors.primary.normal,
    calendarMonthDayFocusTextColor: theme.colors.body.textLight,

    // button in navigation
    calendarNavButtonFontSize: theme.typography.fontSize.m,
    calendarNavButtonColor: theme.colors.body.text,
    calendarNavButtonFontWeight: theme.typography.fontWeight.bold,
  }) as const;
